import { defineNuxtRouteMiddleware, navigateTo } from 'nuxt/app'

function normalizeFacetPath(path: string): string {
  const [basePath, facetSection] = path.split('/-/')
  if (!facetSection) {
    return path
  }

  const facets = facetSection.split('/')
  const uniqueFacets = [...new Set(facets)].filter(Boolean)

  if (facets.length === uniqueFacets.length) {
    return path
  }

  return uniqueFacets.length
    ? `${basePath}/-/${uniqueFacets.join('/')}/`
    : basePath
}

export default defineNuxtRouteMiddleware((to) => {
  const normalizedPath = normalizeFacetPath(to.path)
  if (normalizedPath !== to.path) {
    return navigateTo(normalizedPath, { redirectCode: 301 })
  }
})
